import { router } from '@inertiajs/vue3';
import { showToast } from './showToast';

let registered = false;

/**
 * Shows every toast the server flashes. Call once at app startup: the listener
 * is global, so layouts remounting on navigation cannot stack duplicates.
 * Guarded so a second call (HMR re-running app.js) does not register again.
 */
export function registerToastFlashListener(): void {
  if (registered) {
    return;
  }
  registered = true;

  router.on('flash', (event) => {
    event.detail.flash.toasts?.forEach((toastData) => showToast(toastData));
  });
}
